import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  GetConfigResponse
} from '../types';
import { apiRoutes } from './apiRoutes';
import { getPageUrl } from '../utils';
import { CsError } from './CsError';
import { unauthedQueryFunction } from './apiFunctions/queryFunctions/unauthedQueryFunction';

type ApiQueryKey = readonly [string, ...readonly string[]] 

type ApiOptionsType<TQueryFnData, TData = TQueryFnData> = Omit<UseQueryOptions<TQueryFnData, CsError, TData, ApiQueryKey>, 'queryKey' | 'queryFn'>

export function useGetConfig(queryOptions?: ApiOptionsType<GetConfigResponse>) {
  const pageUrl = getPageUrl()
  return useApiUnauthedQuery<GetConfigResponse>(apiRoutes.getConfig(pageUrl), {
    ...queryOptions,
  })
}

//This is copy-pasted from useApiQuery because useApiQuery uses useOrganization which causes a loop because useGetConfig would then need useOrganization.
export function useApiUnauthedQuery<TResponse, TResult = TResponse>(
  path: string,
  queryOptions?: ApiOptionsType<TResponse, TResult>,
  queryKeyAddon?: string[] 
) {
  const queryKey: ApiQueryKey = queryKeyAddon && Array.isArray(queryKeyAddon) ? [path, ...queryKeyAddon] : [path]

  const STALE_TIME_20S = 1000 * 20
  return useQuery<TResponse, CsError, TResult, ApiQueryKey>({
    staleTime: STALE_TIME_20S,
    refetchOnWindowFocus: false,
    ...queryOptions,
    queryKey,
    queryFn: () => {
      return unauthedQueryFunction<TResponse>(path)
    }
  })
}
